import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password, remember = false) => {
    try {
      await api.post("/auth/login", { email, password, remember });
      const me = await api.get("/auth/me");
      setUser(me.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (email, password, name) => {
    try {
      await api.post("/auth/register", { email, password, name });
      const me = await api.get("/auth/me");
      setUser(me.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const changePassword = async (current_password, new_password) => {
    try {
      await api.post("/auth/change-password", { current_password, new_password });
      const me = await api.get("/auth/me");
      setUser(me.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const refresh = async () => {
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
      return me.data;
    } catch (_) {
      setUser(false);
      return null;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, changePassword, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
